// THE CREATION CARD'S GLYPHS, ONCE (busy-my-web#641, Pouria 2026-10-16).
//
// The Briefing strip and the action row under it said the same things with different drawings:
// "★ Important" wore the pack's sharp five-point `important-bold` while the toolbar's lit toggle
// wore the rounded `star-bold` beside it, and "Waiting on" wore `waiting-on` over the toolbar's
// `clock`. Figma (file Os2uqvgQeMQBhMEhrWiy33, frame 40008539:200623) draws ONE glyph per fact —
// vuesax/bold/star in #EAB308 at 18px in the briefing and 20px in the bar — so a fact and the
// toolbar button that sets it now read their glyph from here, by pack name, and can never drift.
//
// The names resolve through lib/icons/registry like every other pack icon. `important-star` and
// `edit-3` are the Figma exports' own paths (fill → currentColor), so the caller colours them.

/** The Important star — vuesax/bold/star (the briefing fact and the lit toolbar toggle). */
export const IMPORTANT_GLYPH = 'important-star'
/** …and its colour, the frame's #EAB308 — the toolbar's lit face and the fact's glyph alike. */
export const IMPORTANT_COLOR = '#eab308'
/** Waiting on — vuesax/outline/clock (the toolbar's idle face and the briefing fact). */
export const WAITING_GLYPH = 'clock'
/** The checklist — vuesax/outline/task-square. */
export const CHECKLIST_GLYPH = 'task-square'
/** The date — vuesax/outline/calendar-2. */
export const DATE_GLYPH = 'calendar-2'
/** The Create pencil — iconsax/linear/edit-3 (desktop chip and the phone's badged module glyph). */
export const CREATE_GLYPH = 'edit-3'

/**
 * Which glyph a briefing fact and its toolbar toggle share, by the fact's key. A fact with no
 * toolbar twin (the reminder bell, the paperclip, …) is not listed and keeps its own icon.
 */
export const SHARED_FACT_GLYPHS = Object.freeze({
  important: IMPORTANT_GLYPH,
  waiting: WAITING_GLYPH,
  checklist: CHECKLIST_GLYPH,
  due: DATE_GLYPH,
})

export default SHARED_FACT_GLYPHS
